import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes using clsx and tailwind-merge
 * Allows for dynamic class composition while properly handling conflicting classes
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
